import styled from 'styled-components';

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const ViewportOverlay = styled.div`
  color: ${(props) => props.theme.colors.smokeWhite};
  position: absolute;
  top: 5px;
  left: 5px;
  width: 95%;
  height: 95%;

  // font size from viewport scale
  font-size: ${(props) => props.size}em;

  font-weight: 400;
  text-shadow: 1px 1px #000;
  pointer-events: none;
`;

export const TopLeft = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
`;

export const TopCenter = styled.div`
  top: 14px;
  padding-top: 20px;
  width: 100%;
  text-align: center;
`;

export const TopRight = styled.div`
  position: absolute;
  top: 14px;
  right: 20px;
  text-align: right;
`;

export const BottomLeft = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
`;

export const BottomRight = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  text-align: right;
`;
export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const Icon = styled.div`
  display: flex;
  flex-direction: row-reverse;
  cursor: pointer;
  align-self: flex-start;
  z-index: 3;
  pointer-events: auto;
  padding: 0.2em;
  p {
    margin: 0 4em;
  }

  color: ${(props) => props.theme.colors.highlight};
  &.selected {
    svg {
      fill: ${(props) => props.theme.colors.highlightActive};
    }
  }

  :hover {
    svg {
      fill: ${(props) => props.theme.colors.white};
    }
  }
`;

export const Tooltip = styled.div`
  color: ${(props) => props.theme.colors.highlight};
  padding: 0em 1em;
  font-size: 1em;
`;

export const PlayButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;

  &.selected {
    color: ${(props) => props.theme.colors.highlightActive};
  }
`;
